import { useState } from "react";
import { COLOR_FIELDS, PALETTES, sameTheme, themeOf, themeStyle } from "../../menuTheme.js";
import { MenuHeader, MenuItem } from "../menu/MenuParts.jsx";
import "../../menu.css";

const pick = themeOf;
const same = sameTheme;

const ColorPicker = ({ business, products, onSave }) => {

    const [colors, setColors] = useState(() => pick(business));
    const [saving, setSaving] = useState(false);
    const [custom, setCustom] = useState(() => !PALETTES.some((p) => same(p, pick(business))));

    const saved = pick(business);
    const dirty = !same(colors, saved);
    const sample = products.find((p) => !p.agotado) || products[0] || { id: "ejemplo", name: "Tu producto", description: "Así se ve la descripción.", price: 0 };
    const categories = (business.categories || []).slice(0, 3);

    const handleSave = async () => {
        setSaving(true);
        await onSave(colors);
        setSaving(false);
    }

  return (
    <div className="lp-panel-stack">
        <div className="lp-panel-palettes" role="group" aria-label="Paletas">
            {PALETTES.map((p) => {
                const on = same(p, colors);
                return (
                    <button key={p.name} type="button" className={on ? "lp-panel-palette lp-panel-palette-on" : "lp-panel-palette"} aria-pressed={on} onClick={() => setColors(pick(p))}>
                        <span className="lp-panel-palette-dots" aria-hidden="true">
                            <i style={{ background: p.bodyColor }}></i>
                            <i style={{ background: p.selectColor }}></i>
                            <i style={{ background: p.buttonColor }}></i>
                        </span>
                        {p.name}
                    </button>
                )
            })}
        </div>

        <button type="button" className="lp-text-link lp-panel-left" aria-expanded={custom} onClick={() => setCustom(!custom)}>
            {custom ? "Ocultar colores a mano" : "Elegir cada color a mano"}
        </button>

        {custom &&
            <div className="lp-panel-color-fields">
                {COLOR_FIELDS.map(([key, label]) => (
                    <label key={key} className="lp-panel-color-field">
                        <input type="color" value={colors[key]} onChange={(e) => setColors((c) => ({ ...c, [key]: e.target.value }))}/>
                        {label}
                    </label>
                ))}
            </div>
        }

        <div>
            <span className="lp-panel-label">Así lo ven tus clientes</span>
            <div className="lp-menu lp-menu-preview" style={themeStyle(colors)} aria-hidden="true">
                <div className="lp-menu-page">
                    <MenuHeader business={business} preview></MenuHeader>
                    {categories.length > 1 &&
                        <div className="lp-menu-bar">
                            <div className="lp-menu-chips">
                                {["Todo", ...categories].map((c, i) => <span key={c} className={i === 0 ? "lp-menu-chip lp-menu-chip-on" : "lp-menu-chip"}>{c}</span>)}
                            </div>
                        </div>
                    }
                    <div className="lp-menu-main">
                        <div className="lp-menu-items"><MenuItem product={sample}></MenuItem></div>
                    </div>
                </div>
            </div>
        </div>

        <div className="lp-panel-actions">
            <button type="button" className="lp-btn lp-btn-primary" disabled={!dirty || saving} onClick={handleSave}>{saving ? "Guardando..." : dirty ? "Guardar colores" : "Colores guardados"}</button>
            {dirty && <button type="button" className="lp-btn lp-btn-secondary" onClick={() => setColors(saved)}>Descartar</button>}
        </div>
    </div>
  )
}

export default ColorPicker
